import { Component, Input } from '@angular/core'
import {
  MbCheckoutBaseFormPartialComponent
} from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'
import { Region } from '@spartacus/core'
import { Observable } from 'rxjs'
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators'

@Component({
  selector: 'mb-checkout-state-form-partial',
  templateUrl: './mb-checkout-state-form-partial.component.html',
  styleUrls: ['./mb-checkout-state-form-partial.component.scss']
})
export class MbCheckoutStateFormPartialComponent extends MbCheckoutBaseFormPartialComponent {

  @Input() regions: Region[] = []
  @Input() selectedRegion: Region = {}
  @Input() regionLabelKey = 'address.state'
  selectedStateName = ''

  search = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => {
      this.selectedStateName = term
      if (term?.length < 1) {
        return this.regions.map(state => state?.name)
      } else {
        return this.regions.filter(state => state?.name && state.name.toLowerCase().indexOf(term.toLowerCase()) > -1)
          .map(state => state?.name).slice(0, 10)
      }
    })
  )

  onStateSelection (regionName: string) {
    this.selectedRegion = this.regions.find(region => region.name === regionName) ?? {}
    this.address = {
      ...this.address,
      region: this.selectedRegion,
    }
    this.selectedStateName = this.selectedRegion.name ?? ''
    this.formGroup?.patchValue({ region: this.selectedRegion })
  }

  updatedSelectedStateOnBlur () {
    this.selectedRegion = this.regions.find(region => region.name === this.selectedStateName) ?? {}
    if (!Object.keys(this.selectedRegion).length) {
      this.selectedStateName = ''
      this.formGroup?.patchValue({ region: null })
    } else {
      this.formGroup?.patchValue({ region: this.selectedRegion })
    }
  }

  onFocus (event: any) {
    if (!this.selectedRegion.name) {
      event.target.dispatchEvent(new Event('input'))
    }
  }
}
